import { store } from '../index';
import axios from "axios";
import {
    TOKEN_KEY,
    PAYTM_INI_PAYMENT,
    REZORPAY_INI_PAYMENT,
    PAYMENTS_PAY,
    ACK_PAGE_URL
} from "./constant";
import { computeCheckoutTotals } from "./order_helper";

let optionAxios = {
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        "x-api-source": "webapp"
    },
};

const paytmInitiatePayment = async (input) => {
    let user = store.getState().sessionReducer || {};
    const {token, store_id} = user;
    input = { ...input, store_id};
    optionAxios.headers.authorization = token;
    return await axios
        .post(PAYTM_INI_PAYMENT, input, optionAxios)
        .then(function(resp) {
            return resp.data.data;
        })
        .catch((error) => {
            if(error?.response?.status === 401){
                window.location.href = "/rescan";
            }
        });
};

const razorpayInitiatePayment = async (input) => {
    let user = store.getState().sessionReducer || {};
    const {token, store_id} = user;
    input = { ...input, store_id};
    optionAxios.headers.authorization = token;
    return await axios
        .post(REZORPAY_INI_PAYMENT, input, optionAxios)
        .then(function(resp) {
            return resp.data.data;
        })
        .catch((error) => {
            if(error?.response?.status === 401){
                window.location.href = "/rescan";
            }
        });
};

const initiate_payment = async () => {
    const state = store.getState();
    const session = state.sessionReducer || {};
    const cart = state.cartReducer || {};
    const customer = state.customerReducer || {};
    const { token } = session;

    const store_id = session.store_details?.store_id || "";
    const store_details = { store_id };
    const payment_code = cart.selectedTender?.tnd_code || "";

    const isFSR = session?.is_fsr === true;
    const tableNo = String(
        session?.table_details?.table_id ||
        session?.table_details?.table_no || ""
    ).trim();
    const activeOrder = isFSR
        ? customer?.active_table_orders?.[tableNo]?.order || null
        : null;

    let item_details;
    let transaction_grand_amount;
    let offline_invoice_no = cart.offline_invoice_no;
    let sourceItems;

    if (isFSR && activeOrder) {
        item_details = activeOrder.item_details || [];
        sourceItems  = item_details;
        offline_invoice_no = activeOrder.offline_invoice_no || offline_invoice_no;
    } else {
        item_details = cart.addedItems || [];
        sourceItems  = cart.addedItems || [];
    }

    // Prefer engineDiscount item_details (post-offer, per-item discount_amount
    // populated) so gateway payload matches the transaction_grand_amount below.
    // Falls back to raw addedItems when no offer is applied.
    const engineItemsFromOffer = cart?.engineDiscount?.item_details;
    if (!isFSR && Array.isArray(engineItemsFromOffer) && engineItemsFromOffer.length > 0) {
        item_details = engineItemsFromOffer;
    }

    // applyCurrentOffer:true → helper folds any applied offer + current tip
    // through refreshCalculation with the selected tender's round-off. Gateway
    // charge amount matches the display total shown to the user.
    const engineResult = computeCheckoutTotals(sourceItems, {
        orderType:         cart.orderType?.order?.order_type,
        storeId:           store_id,
        paymentOption:     cart.selectedTender,
        storeConfig:       session.store_config,
        tip:               cart?.tip || 0,
        applyCurrentOffer: true,
    });
    transaction_grand_amount = parseFloat(engineResult?.transaction_grand_amount ?? 0);

    if (!offline_invoice_no) {
        offline_invoice_no = `QR-1-${Date.now()}`;
        store.dispatch({ type: "SET_OFFLINE_INVOICE_NO", offline_invoice_no });
    }
    if (offline_invoice_no) {
        localStorage.setItem("offline_invoice_no", offline_invoice_no);
    }

    const payload = {
        store_id,
        store_details,
        item_details,
        transaction_grand_amount,
        payment_code,
        offline_invoice_no,
        ack_page: ACK_PAGE_URL,
        type: "web",
    };

    optionAxios.headers.authorization = token;
    return await axios
        .post(PAYMENTS_PAY, payload, optionAxios)
        .then((resp) => resp.data)
        .catch((error) => {
            if (error?.response?.status === 401) {
                window.location.href = "/rescan";
            }
            return null;
        });
};

export {
    paytmInitiatePayment,
    razorpayInitiatePayment,
    initiate_payment
};
